
//
customElements.define('table-quick-search', class extends HTMLElement {

    //
    constructor() {
        super();
    }

    //
    connectedCallback() {

        //
        const template = document.createElement('template');
        template.innerHTML = `
            <style>
                :host { position: relative; isolation: isolate; }
                .search-input-wrapper { position: relative; text-align: right; z-index: 100; }
                .search-input-wrapper .search-input { padding: 0.5em; }
                .search-input-wrapper .search-input.absolute { position: absolute; right: 0; }
                .no-results { font-weight: bold; text-align: center; }
            </style>
            <div class="search-input-wrapper">
                <input type="text" class="search-input" placeholder="Enter your search term...">
            </div>
            <slot></slot>
            <div class="no-results" style="display: none;">No results found</div>
        `;

        //create the shadow root
        this._shadowRoot = this.attachShadow({ 'mode': 'closed' });
        this._shadowRoot.appendChild(template.content.cloneNode(true));

        //if the first item in the light-dom is not a table - the assume we have a title - so position the search absolutely
        if (!this.firstElementChild.matches('table')) {
            this._shadowRoot.querySelector('.search-input').classList.add('absolute')
        }

        //get the input element
        const input = this._shadowRoot.querySelector('.search-input');

        //get the message element for displaying no results
        const noResults = this._shadowRoot.querySelector('.no-results');

        //add event listener for the input keyup event
        input.addEventListener('input', () => {

            //
            const searchTerm = input.value.toLowerCase();

            //
            let matchFound = false;

            // Loop through all table rows, hide the ones that don't match the search term
            this.querySelectorAll('table tbody tr').forEach((row) => {

                //
                let rowVisible = false;

                //
                const cellContents = Array.from(row.querySelectorAll('th, td')).reduce((a, c) => {
                    return a + ' ' + c.textContent.toLowerCase();
                }, '');

                //
                if (cellContents.includes(searchTerm)) {
                    rowVisible = true;
                    matchFound = true;
                }

                //
                row.style.display = rowVisible ? 'table-row' : 'none';

            });

            // Show/hide the no results message based on matchFound
            noResults.style.display = matchFound ? 'none' : 'block';

        });

    }

});